import {Injectable} from '@angular/core';
import {ApiService} from './api.service';
import {Customer} from '../models/customer.model';
import {RegisterForm} from "../models/user.model";
import {RegisterProfileForm} from "../models/profile.model";

@Injectable({
    providedIn: 'root',
})
export class RegisterService {
    constructor(private apiService: ApiService) {
    }

    // Register a new customer
    async registerCustomer(
        customerData: RegisterForm,
        profileData: RegisterProfileForm
    ): Promise<Customer> {
        const requestBody = {
            Customer: customerData,
            Profile: profileData,
        };

        return await this.apiService.post<Customer>('/registers', requestBody);
    }
}
